/**
 * menu-base.js
 */

import React from 'react';
import { List, Collapse } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useLocation } from "react-router-dom";
import { UserContext } from 'contexts/user/user-context';
import { Types } from 'utils/constants';
import Icon from 'components/icon';
import MenuItem from './menu-item';
import MenuHandler from './menu-handler';
import MenuSupervisor from './menu-supervisor';
import MenuTrainer from './menu-trainer';
import MobileItems from './mobile-items';
// PT1-RETIRE
import MenuHandlerApp from './menu-handler-app';
import { renderForMobileContext } from 'utils/app-context';


const useStyles = makeStyles(theme => ({
  menu: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(4),
    },
  },
  mobileMenuItems: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
    borderTop: `1px solid ${theme.palette.grey.colors[3]}`,
  },
  badge: {
    fontSize: theme.typography.sizes[1],
    fontWeight: 600,
  },
}));


// menu base 
function MenuBase (props) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState({});
  let location = useLocation();
  const path = location.pathname.toLowerCase().trimRight('/');
  const isIE = /*@cc_on!@*/false || !!document.documentMode;


  // build toggled object on first mount
  React.useEffect(() => {
    let initExpanded = {};
    props.items.map((item, index) => {
      if (item.items && !initExpanded[item.title]) {
        // look for active menu link to determine parent expansion state
        initExpanded[item.title] = item.items.find(subItem => {
          // to re-enable expansion, remove default of true and enable the next line
          return true;
          //return isActive(subItem);
        }) !== undefined;
      }
      return item;
    });
    setExpanded(initExpanded);
  }, [props.items]);


  // checks if menu item should be active
  const isActive = (item) => {
    // if (item.items) {
    //   return false;
    // }

    if (item.title === "Home") {
      return path === "" || path === item.link;
    }

    // put all possible matches in an array and test
    return [
      item.link || item.route,
      ...(item.extraMatches || [])
    ].find(match => {
      match = match ? match.toLowerCase() : '';
      return path === match
        || (path.startsWith(match) 
          && match !== '/training' // very hack but only temp
          && path.replace(match, '').startsWith('/'));
    }) !== undefined;
  }


  const click = (item) => {
    // if (item.items) {
    //   setExpanded({...expanded, [item.title]: !expanded[item.title]});
    // } 

    if (props.onSelect) {
      props.onSelect(item);
    }
  }

   
  return (
    <>
      {props.items && <>
        <List className={classes.menu}>
          {props.items.map((item, itemIndex) => (
            <div key={item.title}>
              {!(isIE && item.disableIE) &&
              <>
                <MenuItem 
                  {...item}
                  parent={item.items} 
                  active={isActive(item)}
                  onClick={() => click(item)}
                  open={expanded[item.title]}
                  index={itemIndex}
                />
                {item.items && 
                <Collapse in={expanded[item.title]} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.items.map((subItem, subItemIndex) => (
                      <MenuItem 
                        {...subItem}
                        key={subItem.title} 
                        child={true} 
                        active={isActive(subItem)} 
                        onClick={() => click(item)}
                      />
                    ))}
                  </List>
                </Collapse>}
              </>}
            </div>
          ))}
        </List>

        {/* mobile priority (app-bar) items */}
        <MobileItems onSelect={props.onSelect} />
      </>}
    </>
  );
}

// variant menu
export default function Menu (props) {
  const { user } = React.useContext(UserContext);

  const handlerMenu = [...MenuHandler];
  const handlerMenuApp = [...MenuHandlerApp];

  if (user.unresolvedRecoveryCount) {
    const recoveryMenuItem = { title: 'File Recovery', route: '/recovery', icon: <Icon type='copy' /> };
    handlerMenu.push(recoveryMenuItem);
    handlerMenuApp.push(recoveryMenuItem);
  }

  const menus = {
    // PT1-RETIRE (alt mobile menu)
    [Types.Role.HANDLER]: renderForMobileContext() ? handlerMenuApp : handlerMenu,
    [Types.Role.SUPERVISOR]: MenuSupervisor,
    [Types.Role.TRAINER]: MenuTrainer,
  };
  const items = menus[user?.role?.id];
  return (
    <MenuBase items={items} {...props} />
  )
}